import { ComponentType, SVGProps } from "react"
import IconHome from '@/assets/img/Icon_Home.svg'
import IconCatalogue from '@/assets/img/Icon_Catalogue.svg'
import IconOurApps from '@/assets/img/Icon_OurApps.svg'
import IconChooseUs from '@/assets/img/Icon_ChooseUs.svg'
import { useUserStore } from "@/stores/useUserStore"

export type MenuDataItem = {
	title: string
	url: string
	icon: ComponentType<SVGProps<SVGSVGElement>>
	guard?: () => boolean
}

const getMenuData = ():MenuDataItem[] => {
	const { userId, profileId } = useUserStore.getState() // 👈 acceso sin hook

	return [
		{
			title: 'advantages',
			icon: IconChooseUs,
			url: '/',
			guard: () => !userId
		},
		{
			title: 'home',
			icon: IconHome,
			url: '/home',
		},
		{
			title: 'catalogue',
			icon: IconCatalogue,
			url: '/catalogue',
		}
	]
} 

export default getMenuData